import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";
import type { IReclaimPurchaseInvoiceReturnDto } from "@api/stores/purchaseInvoices/returns/reclaim/types";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IReclaimPurchaseInvoiceReturnDto
>("stores.purchaseInvoices.returns.reclaim");

export const reclaim = {
  ...postApis,
};
